import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import HowItWorks from "./components/HowItWorks";
import About from "./components/About";
import PetShop from "./components/PetShop";
import Emergency from "./components/Emergency";
import Testimonials from "./components/Testimonials";
import JoinUs from "./components/JoinUs";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";

const App = () => {
  return (
    <div className="min-h-screen flex flex-col font-sans bg-brand-light">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <Stats />
        <HowItWorks />
        <About />
        <PetShop />
        <Emergency />
        <Testimonials />
        <JoinUs />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default App;
